"use strict";

exports.__esModule = true;
exports.default = times;
var _optimizeCb = _interopRequireDefault(require("./_optimizeCb.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Run a function **n** times.
function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = (0, _optimizeCb.default)(iteratee, context, 1);
  for (var i = 0; i < n; i++) accum[i] = iteratee(i);
  return accum;
}